// src/redux/rootReducer.js
import { combineReducers } from "redux";
import uiReducer from "./Ui/ui.slice";
import filterReducer from "./Filter/filterSlice"; // ← add

const rootReducer = combineReducers({
  ui: uiReducer,
  persistedFilters: filterReducer, // ← add
});

export default rootReducer;